export const GET_PROFILE = "GET_PROFILE"
export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS"

export const UPDATE_PROFILE = "UPDATE_PROFILE"
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS"

export const UPDATE_PROFILE_META_TAGS = "UPDATE_PROFILE_META_TAGS"
export const UPDATE_PROFILE_META_TAGS_SUCCESS =
  "UPDATE_PROFILE_META_TAGS_SUCCESS"

export const GET_ROLES = "GET_ROLES"
export const GET_ROLES_SUCCESS = "GET_ROLES_SUCCESS"

export const API_ERROR = "API_ERROR"

export const OPEN_CHANGE_PASSWORD_MODAL = "OPEN_CHANGE_PASSWORD_MODAL"
export const HIDE_CHANGE_PASSWORD_MODAL = "HIDE_CHANGE_PASSWORD_MODAL"

export const CHANGE_PASSWORD = "CHANGE_PASSWORD"
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS"
export const CHANGE_PASSWORD_FAILED = "CHANGE_PASSWORD_FAILED"

export const OPEN_CHANGE_PASSWORD_FAILURE_MODAL =
  "OPEN_CHANGE_PASSWORD_FAILURE_MODAL"
export const HIDE_CHANGE_PASSWORD_FAILURE_MODAL =
  "HIDE_CHANGE_PASSWORD_FAILURE_MODAL"

export const GET_EVENT_TEASER = "GET_EVENT_TEASER"
export const GET_EVENT_TEASER_SUCCESS = "GET_EVENT_TEASER_SUCCESS"
export const RESET_EVENT_TEASER = "RESET_EVENT_TEASER"

export const DELETE_ADMIN_USER = "DELETE_ADMIN_USER"
export const DELETE_ADMIN_USER_SUCCESS = "DELETE_ADMIN_USER_SUCCESS"
export const DELETE_ADMIN_USER_FAILED = "DELETE_ADMIN_USER_FAILED"

export const CREATE_ADMIN_USER = "CREATE_ADMIN_USER"
export const CREATE_ADMIN_USER_SUCCESS = "CREATE_ADMIN_USER_SUCCESS"
export const CREATE_ADMIN_USER_FAILED = "CREATE_ADMIN_USER_FAILED"

export const UPDATE_ADMIN_USER = "UPDATE_ADMIN_USER"
export const UPDATE_ADMIN_USER_SUCCESS = "UPDATE_ADMIN_USER_SUCCESS"
export const UPDATE_ADMIN_USER_FAILED = "UPDATE_ADMIN_USER_FAILED"

export const GET_USER_PROFILE = "GET_USER_PROFILE"
export const GET_USER_PROFILE_SUCCESS = "GET_USER_PROFILE_SUCCESS"
export const GET_USER_PROFILE_FAILED = "GET_USER_PROFILE_FAILED"
export const RESET_USER_PROFILE = "RESET_USER_PROFILE"

export const OPEN_PWD_SECURITY_CHECK_MODAL = "OPEN_PWD_SECURITY_CHECK_MODAL"
export const HIDE_PWD_SECURITY_CHECK_MODAL = "HIDE_PWD_SECURITY_CHECK_MODAL"
export const PWD_SECURITY_CHECK = "PWD_SECURITY_CHECK"
export const PWD_SECURITY_CHECK_SUCCESS = "PWD_SECURITY_CHECK_SUCCESS"
export const PWD_SECURITY_CHECK_FAILED = "PWD_SECURITY_CHECK_FAILED"
